import React from 'react';
import { ContextProviderComponent } from 'components/Context';
import { LayoutProvider } from 'context/LayoutContext';
import StockTicker from 'components/StockTicker';

/**
 * Note that this file must remain src/layouts/index.js
 * in order for the gatsby-plugin-layout plugin to work
 * properly.
 *
 * If it needs to change, then the config for that plugin
 * will need to be updated to point to the new file location.
 *
 * @see https://www.gatsbyjs.org/packages/gatsby-plugin-layout/
 */
function WrappingLayout({ children }) {
  return (
    <ContextProviderComponent>
      <LayoutProvider>
        {children}
      </LayoutProvider>
    </ContextProviderComponent>
  );
}

export default WrappingLayout;
